export class CreditCardRefundRequest {
  public constructor() {
    this.CreditCardTransactionId = 0;
    this.RefundAmount = 0;
    this.RefundReason = '';
    this.CreateAdjustments = false;
    this.AdjustmentTypeId = 0;
  }

  public CreditCardTransactionId: number;
  public RefundAmount: number;
  public RefundReason: string;
  public CreateAdjustments: boolean;
  public AdjustmentTypeId: number;
}
